import * as FiIcons from 'react-icons/fi';

const {
  FiGrid,
  FiShoppingBag,
  FiPackage,
  FiLayers,
  FiBarChart2,
  FiPercent,
  FiTruck,
  FiUsers,
  FiImage,
  FiSettings,
  FiCalendar,
  FiStar
} = FiIcons;

export const adminNavGroups = [
  {
    group: 'OVERVIEW',
    items: [
      { id: 'overview', label: 'Dashboard', icon: FiGrid }
    ]
  },
  {
    group: 'ORDERS',
    items: [
      {
        id: 'orders',
        label: 'All Orders',
        icon: FiShoppingBag,
        badgeKey: 'paymentReview'
      },
      { id: 'try-on', label: 'Try-on Requests', icon: FiCalendar }
    ]
  },
  {
    group: 'CATALOGUE',
    items: [
      { id: 'products', label: 'Products & Stock', icon: FiPackage },
      { id: 'categories', label: 'Categories', icon: FiLayers }
    ]
  },
  {
    group: 'INVENTORY',
    items: [
      { id: 'inventory', label: 'Stock Report', icon: FiBarChart2 }
    ]
  },
  {
    group: 'MARKETING',
    items: [
      { id: 'promotions', label: 'Promo Codes', icon: FiPercent }
    ]
  },
  {
    group: 'CUSTOMERS',
    items: [
      { id: 'customers', label: 'Customers', icon: FiUsers }
    ]
  },
  {
    group: 'CONTENT',
    items: [
      { id: 'reviews', label: 'Review Management', icon: FiStar }
    ]
  },
  {
    group: 'SETTINGS',
    items: [
      { id: 'landing', label: 'Website Photos', icon: FiImage },
      { id: 'shipping', label: 'Shipping & Delivery', icon: FiTruck },
      { id: 'settings', label: 'Payment Methods', icon: FiSettings }
    ]
  }
];